import React from "react"
import { withPlayButton } from "core/utils"

const Image = ({ attributes, images, editing }) => {
  return (
    <td
      {...attributes}
      style={{
        verticalAlign: "top",
        textAlign: "center",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        borderCollapse: "collapse",
        height: "80px"
      }}
      background={images}
    >
      {!editing && (
        <outlook-only>
          <img
            width="80"
            height="80"
            src={withPlayButton({
              src: images,
              width: 80,
              height: 80,
              accent: "rgba(0,0,0,.5)",
              play: "white",
              stroke: "white"
            })}
            alt="spotify artwork"
          />
        </outlook-only>
      )}
      <except-outlook>
        <div style={{ padding: "20px 20px" }}>
          <div
            style={{
              border: "thin solid white",
              borderRadius: "50%",
              margin: "0 auto",
              height: "40px",
              width: "40px",
              backgroundColor: "rgba(0,0,0,.5)", // fallback for outlook
              backgroundImage:
                "linear-gradient(rgba(0,0,0,.7), 30%, rgba(0,0,0,.3))",
              boxSizing: "border-box",
              verticalAlign: "middle",
              textAlign: "center",
              paddingTop: "11px",
              paddingLeft: "5px"
            }}
          >
            <div
              style={{
                borderColor: `transparent transparent transparent white`,
                borderStyle: "solid",
                borderWidth: "8px 0 8px 16px",
                display: "block",
                fontSize: 0,
                height: 0,
                margin: "0 auto",
                width: 0,
                paddingBottom: "0px"
              }}
            >
              &nbsp;
            </div>
          </div>
        </div>
      </except-outlook>
    </td>
  )
}

export default Image
